// import { errorMessages } from 'client/src/shared/error/constants';
import { httpGet, httpGetBlob } from '../../utils/fetchService';

const baseURL = '/api/reports/planning-and-reports';

export const fecthEntityAnalyticalReviewReport = async ({
  taxYear,
  shortYearId,
  orgId,
  businessId,
}) => {
  const blob = await httpGetBlob({
    route: `${baseURL}/entity-analytical-review/${taxYear}/${shortYearId}/${orgId}`,
    errorMessage: 'Error generating Entity Analytical Review Report',
  });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Entity_Analytical_Review_${taxYear}_${businessId}_${orgId}.xlsm`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const fetchConsolStateConsolidatedReport = async ({
  taxYear,
  shortYearId,
  consolId,
  jurisdictionId,
}) => {
  const jurisdictionResponse = await httpGet({
    route: `${baseURL}/jurisdiction-description/${jurisdictionId}`,
    errorMessage: 'Error finding Jurisdictio Description',
  });

  const jurisdictionDescription = await jurisdictionResponse.text();

  const blob = await httpGetBlob({
    route: `${baseURL}/consol-state-consolidated/${taxYear}/${shortYearId}/${consolId}`,
    errorMessage: 'Error generating Consol State Consolidated Report',
  });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `State_Consolidated_Report_${taxYear}_${jurisdictionDescription}_${consolId}.xlsm`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const fetchNexusConsolAnalysisReport = async ({
  taxYear,
  shortYearId,
  consolId,
  jurisdictionId,
}) => {
  const jurisdictionResponse = await httpGet({
    route: `${baseURL}/jurisdiction-description/${jurisdictionId}`,
    errorMessage: 'Error finding Jurisdictio Description',
  });

  const jurisdictionDescription = await jurisdictionResponse.text();

  const blob = await httpGetBlob({
    route: `${baseURL}/consol-nexus-analysis/${taxYear}/${shortYearId}/${consolId}/${jurisdictionId}`,
    errorMessage: 'Error generating Consol Nexus Analysis Report',
  });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Consol_Nexus_Analysis_Report_${taxYear}_${jurisdictionDescription}_${consolId}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const fetchInterCompanyDividendAnalysisReport = async ({
  taxYear,
  shortYearId,
  consolId,
  jurisdictionId,
}) => {
  const jurisdictionResponse = await httpGet({
    route: `${baseURL}/jurisdiction-description/${jurisdictionId}`,
    errorMessage: 'Error finding Jurisdiction Description',
  });

  const jurisdictionDescription = await jurisdictionResponse.text();

  const blob = await httpGetBlob({
    route: `${baseURL}/intercompany-dividend-analysis/${taxYear}/${shortYearId}/${consolId}/${jurisdictionId}`,
    errorMessage: 'Error generating Intercompany Dividend Analysis Report',
  });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Intercompany_Dividend_Analysis_Report_${taxYear}_${jurisdictionDescription}_${consolId}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const fetchConsolSTISummaryPushbackStatesReport = async ({
  taxYear,
  shortYearId,
  consolId,
  jurisdictionId,
}) => {
  const jurisdictionResponse = await httpGet({
    route: `${baseURL}/jurisdiction-description/${jurisdictionId}`,
    errorMessage: 'Error finding Jurisdiction Description',
  });
  const jurisdictionDescription = await jurisdictionResponse.text();
  const blob = await httpGetBlob({
    route: `${baseURL}/consol-sti-summary-pushback-states/${taxYear}/${shortYearId}/${consolId}`,
    errorMessage: 'Error generating Consol STI Summary Pushback State Report',
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Consol_STI_Summary_Pushback_State_Report_${taxYear}_${jurisdictionDescription}_${consolId}.xlsm`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const fetchConsolSTIReconciliationReport = async ({
  taxYear,
  shortYearId,
  consolId,
  jurisdictionId,
  businessGroup,
}) => {
  const jurisdictionResponse = await httpGet({
    route: `${baseURL}/jurisdiction-description/${jurisdictionId}`,
    errorMessage: 'Error finding Jurisdiction Description',
  });
  const jurisdictionDescription = await jurisdictionResponse.text();
  const blob = await httpGetBlob({
    route: `${baseURL}/consol-sti-reconciliation/${taxYear}/${shortYearId}/${consolId}/${jurisdictionId}/${businessGroup}`,
    errorMessage: 'Error generating Consol STI Reconciliation Report',
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Consol_STI_Reconciliation_Report_${taxYear}_${jurisdictionDescription}_${consolId}_${businessGroup}.xlsm`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
